import {
  SELLER,
  SELLER_LABELS,
  isSellerPlaceholder,
  sellerFieldsShown,
  sellerValue,
} from "@/lib/seller";

/**
 * The seller's details as the legal texts print them, inline in a sentence:
 * „Vardas Pavardė, individualios veiklos pažymos Nr. …, PVM mokėtojo kodas …,
 * adresas". Read from `lib/seller.ts` — the one place they live.
 */
export function SellerIdentity() {
  const parts = [sellerValue("name")];
  parts.push(`individualios veiklos pažymos Nr. ${sellerValue("ivCertificate")}`);
  if (sellerFieldsShown().includes("vatCode")) {
    parts.push(`PVM mokėtojo kodas ${sellerValue("vatCode")}`);
  }
  parts.push(sellerValue("address"));
  return <>{parts.join(", ")}</>;
}

/** The seller's address as a mail link — or the placeholder, which links nowhere. */
export function SellerEmail() {
  if (isSellerPlaceholder(SELLER.email)) return <>{sellerValue("email")}</>;

  return (
    <a href={`mailto:${SELLER.email}`} className="underline underline-offset-4">
      {SELLER.email}
    </a>
  );
}

/** Every detail as a labelled list, for the contacts page. */
export function SellerDetailsList() {
  return (
    <dl className="grid gap-x-6 gap-y-2 sm:grid-cols-[max-content_1fr]">
      {sellerFieldsShown().map((field) => (
        <div key={field} className="contents">
          <dt className="text-muted-foreground">{SELLER_LABELS[field]}</dt>
          <dd className="break-words">{field === "email" ? <SellerEmail /> : sellerValue(field)}</dd>
        </div>
      ))}
    </dl>
  );
}
